/**
 * TODO AIFOLLOWUP ED-18808, EDITOR-56:
 * This should no longer be needed once token case been finalised + added.
 * Once AI tokens are available, replace usages of `aiThemeColor` with
 * the correct tokens.
 */

import { useThemeObserver } from '@atlaskit/tokens';
export const useAIThemeColor = () => {
  const {
    colorMode
  } = useThemeObserver();
  return key => aiTheme[key][colorMode || 'light'];
};
const aiTheme = {
  // Prism border gradient steps
  ['prism.border.step.1']: {
    light: '#1D7AFC',
    // Blue600
    dark: '#0055CC' // Blue800
  },
  ['prism.border.step.2']: {
    light: '#8BDBE5',
    // Teal300
    dark: '#37B4C3' // Teal500
  },
  ['prism.border.step.3']: {
    light: '#F8E6A0',
    // Yellow200
    dark: '#CF9F02' // Yellow500
  },
  // AI Logo Main Blue Color
  ['icon.brand']: {
    light: '#2684FF',
    dark: '#2684FF'
  },
  // Used for the slight gradient in the AI logo
  ['icon.brand.subtle']: {
    light: '#0052CC',
    dark: '#0052CC'
  },
  // Telepointer background gradient steps
  ['telepointer.background.step.1']: {
    light: '#F8E6A0',
    dark: '#F5CD47'
  },
  ['telepointer.background.step.2']: {
    light: '#8BDBE5',
    dark: '#60C6D2'
  },
  ['telepointer.background.step.3']: {
    light: '#0C66E4',
    // Blue700
    dark: '#388BFF' // Blue500
  },
  // Loading dots colours
  ['loading.step.1']: {
    light: '#0C66E4',
    // Blue700
    dark: '#0C66E4' // Blue700
  },
  ['loading.step.2']: {
    light: '#1D7AFC',
    // Blue600
    dark: '#1D7AFC' // Blue600
  },
  ['loading.step.3']: {
    light: '#388BFF',
    // Blue500
    dark: '#388BFF' // Blue500
  }
};